var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoValidationForTurkishMarket = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.002,
    height: 14,
    viewBox: "0 0 18.002 14",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_validation_for_turkish_market",
    transform: "translate(-71.324 -166.956)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48685",
    "data-name": "Path 48685",
    d: "M214.151,209.186l1.649,2.275,2.671-.867-1.652,2.273,1.649,2.275-2.67-.87-1.652,2.274,0-2.811-2.67-.87,2.671-.867Z",
    transform: "translate(-129.147 -38.91)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48686",
    "data-name": "Path 48686",
    d: "M80.5,179.644a5.688,5.688,0,1,1,2.7-10.691,7,7,0,1,0,0,10.008A5.649,5.649,0,0,1,80.5,179.644Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoValidationForTurkishMarket);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_validation_for_turkish_market.ec6b6a255fc805556dcbced41c7b66f4.svg";